export const LANGUAGE_KEY = "vd-lang";